import { usePortalContext } from "../hooks/usePortalContext";

type Props = { merchant: JSX.Element; org: JSX.Element };

/**
 * Routes that exist in both contexts render a different container in each. The
 * routes themselves do not move, which is what lets a drill-down out of an org
 * screen be a context switch rather than a navigation.
 */
const ContextRoute = ({ merchant, org }: Props): JSX.Element => {
  const { context } = usePortalContext();
  return context?.type === "org" ? org : merchant;
};

export default ContextRoute;
